import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import {
  convertToQuery,
  getDeviceType,
  getScreenName,
  removeDefaultParams,
} from '../../../Utils/helper';
import {
  getAutoCompleteKeywords,
  getSearchQueryResult,
} from '../../../datafetchers/Search/Search';
import {
  clickedSearchTabEvent,
  searchQueryEvent,
} from '../../Search/instrumentation';
import SearchResults from '../SearchResults';
import DesktopSearch from './DesktopSearch';
import {
  DeviceStyleDesktop,
  DeviceStyleMobile,
  MobileSearchOverlay,
  SearchSection,
} from './MainHeader/styled';
import MobileSearch from './MobileSearch';
import { CategorySearchMapping } from './constant';
import { changeProductSorting } from '../../Search/utils';
import { fireEvent } from '../../../Utils/fireEvent';

export default function Search(props) {
  const {
    setShowSearchSectionClass,
    showSearchSectionClass,
    overlayHandler,
    newUX,
    showInput,
    setShowInput,
    showNewHeader,
    trendingSearchData,
    isForJoyfulPage,
  } = props;
  const [searchString, setSearchString] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [recentSearch, setRecentSearch] = useState([]);
  const [showCross, setShowCross] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const searchBoxRef = useRef();
  const router = useRouter();
  const timeRef = useRef();

  const closeOnBackClick = (url) => {
    url = url?.split('?').pop();
    if (!url.includes('search')) {
      setShowSearchSectionClass(false);
      setShowInput(false);
      document.body.classList.remove('noScroll');
    }
  };
  const showSearchResultHandler = (e) => {
    setShowSearchSectionClass(true);
    e?.stopPropagation();
    searchBoxRef.current
      ? searchString !== '' && (searchBoxRef.current.style.display = 'block')
      : null;

    clickedSearchTabEvent(true);
  };

  const recentSearchClickHandler = (e, value, index) => {
    changeToSearchRoute(e, value);
    setShowCross(true);
    e.stopPropagation();
    fireEvent({
      category: 'clicked_recent_search',
      screen_name: getScreenName(),
      content_type: 'product',
      name: value,
      position: index,
      query: searchString,
    });
  };

  const trendingSearchClickHandler = (searchString, index) => {
    changeToSearchRoute(undefined, searchString);
    fireEvent({
      category: 'clicked_trending_search',
      screen_name: getScreenName(),
      support_variable: `{query :'${searchString ? searchString : ''}'}`,
      content_type: 'product',
      position: index,
      query: searchString,
    });
  };

  useEffect(() => {
    if (showSearchSectionClass) {
      document.getElementById('searchInput')?.focus();
      document.body.classList.add('noScroll');
    } else {
      document.body.classList.remove('noScroll');
    }
    return () => {
      document.body.classList.remove('noScroll');
    };
  }, [showSearchSectionClass]);

  useEffect(() => {
    setRecentSearch(
      localStorage.getItem('recentSearch')
        ? JSON.parse(localStorage.getItem('recentSearch'))?.split(',')
        : [],
    );
  }, []);

  useEffect(() => {
    if (
      router.query.search &&
      !showSearchSectionClass &&
      !window.location.pathname.includes('/parenting/babynames/search')
    ) {
      const params = new URLSearchParams(window.location.search);
      params.delete('search');
      let path = window.location.pathname;
      if (params) path += +'?' + params;
      router.replace(params, undefined, { scroll: false });
    }
  }, [router.query]);

  useRouterChangeStart(closeOnBackClick);

  const changeToSearchRoute = (e, searchString) => {
    e?.preventDefault();
    if (searchString !== '') {
      searchQueryEvent(searchString);
      const res = [searchString, ...recentSearch];
      if (searchString?.length >= 3) {
        if (recentSearch.length > 4) {
          recentSearch.shift();
          setRecentSearch(res);
        } else {
          setRecentSearch(res);
        }
      }
      let queryString = { ...router.query };
      queryString = removeDefaultParams(queryString);
      queryString = { ...queryString, q: searchString, tag: 'products' };
      queryString = convertToQuery(queryString);
      if (getDeviceType() == 'desktop') {
        searchBoxRef.current
          ? (searchBoxRef.current.style.display = 'none')
          : null;
      }
      let url = '/search?';
      let forcePushToCategory = false;
      for (let i = 0; i < CategorySearchMapping?.length; i++) {
        let categoryObj = CategorySearchMapping[i];
        searchString = decodeURIComponent(searchString);
        if (categoryObj[searchString?.toLowerCase()]) {
          url = categoryObj[searchString?.toLowerCase()];
          forcePushToCategory = true;
          break;
        }
      }
      const isSearchResultPage = getScreenName() == 'search_result';
      if (isSearchResultPage && !forcePushToCategory && !isDesktopUser()) {
        router.replace(url + queryString);
      } else router.push(url + queryString);
    }
  };
  const handleInputChange = (e) => {
    const entered_value = e.target.value;
    setSearchString(entered_value);
    setShowLoader(true);
    debounce(() => {
      getSearchData(entered_value);
    }, 300);
  };

  const debounce = (func, delay) => {
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(func, delay);
  };

  const addDataToResult = (allResult, finaldata, key) => {
    allResult.map((element) => {
      if (element.key === key) {
        const newArr = element?.data?.map((element) => {
          return { ...element, key };
        });
        finaldata.push(...newArr?.slice(0, 5));
      }
    });
  };
  useEffect(() => {
    setSearchString(router.query.q || '');
  }, [router.query.q]);

  const getDataForAutoComplete = (data) => {
    const finalData = [];
    data?.map((element) => {
      let obj = {};
      obj['name'] = element?.term;
      obj['key'] = 'keywords';
      finalData.push(obj);
    });
    return finalData?.slice(0, 4);
  };

  const getModifiedData = (resultData) => {
    const finaldata = [];
    addDataToResult(resultData, finaldata, 'products');
    addDataToResult(resultData, finaldata, 'category');
    return finaldata;
  };
  const getSearchData = async (keyword) => {
    const result = await getSearchQueryResult(keyword, 'category_products', 0);
    let autoCompleteKeywords = null;
    if (keyword) {
      autoCompleteKeywords = await getAutoCompleteKeywords(
        keyword,
        'category_product',
      );
    }
    if (searchString) {
      changeProductSorting(result?.data?.[1]?.data, searchString);
    }
    const modifiedData = getModifiedData(result?.data);
    const autoCompleteData = getDataForAutoComplete(autoCompleteKeywords?.data);

    const finalData = [...autoCompleteData, ...modifiedData];
    setSearchData(finalData);
    setShowLoader(false);
  };

  return (
    <SearchSection
      showNewHeader={showNewHeader}
      newUX={newUX}
      SearchClass={showSearchSectionClass}
      isForJoyfulPage={isForJoyfulPage}
    >
      <>
        <DeviceStyleDesktop isForJoyfulPage={isForJoyfulPage}>
          {(isDesktopUser() || isForJoyfulPage) && (
            <DesktopSearch
              handleInputChange={handleInputChange}
              setShowSearchSectionClass={setShowSearchSectionClass}
              searchString={searchString}
              showSearchResultHandler={showSearchResultHandler}
              searchBoxRef={searchBoxRef}
              changeToSearchRoute={changeToSearchRoute}
              trendingSearchData={trendingSearchData}
              isForJoyfulPage={isForJoyfulPage}
            />
          )}
        </DeviceStyleDesktop>
        <DeviceStyleMobile isForJoyfulPage={isForJoyfulPage}>
          <MobileSearch
            handleInputChange={handleInputChange}
            showSearchResultHandler={showSearchResultHandler}
            searchString={searchString}
            showCross={showCross}
            setShowCross={setShowCross}
            setSearchString={setSearchString}
            changeToSearchRoute={changeToSearchRoute}
            trendingSearchData={trendingSearchData}
            showInput={showInput}
            setShowInput={setShowInput}
            setShowSearchSectionClass={setShowSearchSectionClass}
          />
        </DeviceStyleMobile>
      </>

      {showSearchSectionClass && (
        <MobileSearchOverlay
          onClick={() => {
            overlayHandler();
            setShowInput(false);
          }}
        >
          <SearchResults
            searchData={searchData}
            searchString={searchString}
            searchBoxRef={searchBoxRef}
            recentSearch={recentSearch}
            recentSearchClickHandler={recentSearchClickHandler}
            trendingSearchClickHandler={trendingSearchClickHandler}
            trendingSearchData={trendingSearchData}
            showLoader={showLoader}
            changeToSearchRoute={changeToSearchRoute}
            setShowSearchSectionClass={setShowSearchSectionClass}
          />
        </MobileSearchOverlay>
      )}
    </SearchSection>
  );
}
